import React, { useEffect, useState } from "react";
import { getPaginatedReports } from "../../../_utils/resourceAPI";
import { Report } from "../../../_models/Report.model";
import { Client } from "../../../_models/Client.model";
import { useNavigate } from "react-router-dom";
import { useReportContext } from "../../../_context/ReportContext";
import { ClientSearchAndFilter } from "../../../htmlComponents/clientSearchAndFilter";
import { useClientContext } from "../../../_context/ClientContext";
import "../../Admin/AddUsers/AddUsers.css";
import "../Reports.css";

const LoadingSpinner = () => (
  <div className="rp-spinner-wrap">
    <svg className="rp-spinner" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#2563C0" strokeWidth="2.5" strokeLinecap="round">
      <path d="M21 12a9 9 0 1 1-6.219-8.56" />
    </svg>
    <span>Loading Reports...</span>
  </div>
);

export const AddedReports = () => {
  const navigate = useNavigate();
  const [filteredClients, setFilteredClients] = useState<Client[]>([]);
  const [noDataOrLoadingData, setNoDataOrLoadingData] = useState<string>("");
  const { setClient } = useClientContext();
  const { setFetchedAllReports } = useReportContext();
  const [selectedClient, setSelectedClient] = useState<Client | null>(null);

  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [limit] = useState(20);
  const [total, setTotal] = useState(0);

  const fetchReports = (pageNum = page, clientId = "") => {
    setIsLoading(true);
    getPaginatedReports(limit, pageNum * limit, clientId)
      .then((res) => {
        setFetchedAllReports(res.data.data);
        setTotal(res.data.total);
      })
      .catch((error) => console.log("Failed to fetch reports", error))
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    fetchReports(page, selectedClient ? selectedClient.Id : "");
    // eslint-disable-next-line
  }, [page, selectedClient]);

  const handleClientReportSelect = (client: Client) => {
    setSelectedClient(client);
    setClient(client);
    navigate("/reports/client_reports");
  };

  const totalPages = Math.ceil(total / limit) || 1;

  return (
    <div className="reports-page-wrapper">
      <div className="au-card" style={{ marginBottom: 24 }}>
        <div className="au-card-header">
          <div className="au-card-header-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
              <line x1="3" y1="9" x2="21" y2="9" /><line x1="9" y1="21" x2="9" y2="9" />
            </svg>
          </div>
          <div>
            <p className="au-card-header-title">Select Client to View Reports</p>
            <p className="au-card-header-sub">Search clients to view previously submitted quality reports</p>
          </div>
        </div>

        <div className="au-card-body">
          {isLoading ? (
            <LoadingSpinner />
          ) : (
            <>
              <ClientSearchAndFilter
                setFiltererdClients={setFilteredClients}
                setDataStatus={setNoDataOrLoadingData}
              />

              {/* Pagination Controls */}
              <div className="rp-pagination" style={{ marginTop: 16 }}>
                <span className="rp-pagination-info">
                  Page {page + 1} of {totalPages}
                </span>
                <div style={{ display: "flex", gap: "8px" }}>
                  <button
                    className="rp-pagination-btn"
                    onClick={() => setPage(p => Math.max(0, p - 1))}
                    disabled={page === 0}
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="15 18 9 12 15 6" />
                    </svg>
                    Previous
                  </button>
                  <button
                    className="rp-pagination-btn"
                    onClick={() => setPage(p => (p + 1 < totalPages ? p + 1 : p))}
                    disabled={page + 1 >= totalPages}
                  >
                    Next
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="9 18 15 12 9 6" />
                    </svg>
                  </button>
                </div>
              </div>

              {filteredClients.length > 0 ? (
                <div className="au-table-wrap">
                  <table className="au-table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th style={{ width: "140px" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredClients.map(client => client ? (
                        <tr key={client.Id}>
                          <td>{client.Name}</td>
                          <td style={{ color: "#6B7280" }}>{client.Email}</td>
                          <td>
                            <button
                              className="btn-action btn-primary w-100"
                              style={{ justifyContent: "center" }}
                              onClick={() => handleClientReportSelect(client)}
                            >
                              View Reports
                            </button>
                          </td>
                        </tr>
                      ) : null)}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="au-empty">{noDataOrLoadingData}</div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};
